export var PlayerAdapterVideoFormat;
(function (PlayerAdapterVideoFormat) {
    PlayerAdapterVideoFormat["HLS"] = "hls";
    PlayerAdapterVideoFormat["DASH"] = "dash";
    PlayerAdapterVideoFormat["MP4"] = "mp4";
    PlayerAdapterVideoFormat["UNKNOWN"] = "unknown";
})(PlayerAdapterVideoFormat || (PlayerAdapterVideoFormat = {}));
